<template>
  <div class="connector-list">

    <v-container grid-list-xl fluid>
      <v-sheet
        min-height="300"
        rounded="lg"
        elevation="6"
      >
        <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
          <v-toolbar-title  class="hidden-sd-and-down">
              <h2><v-icon large class="mr-2">mdi-update</v-icon>{{$t('app.connectors')}}</h2>
          </v-toolbar-title>
          <v-spacer />
          <div class="d-inline-flex">
            <v-btn
              class="ml-2"
              :disabled="userHasAccess('application_edit') == 0"
              color="primary"
              @click="startconnector"
            >
              {{ $t('app.startconnector')}}
            </v-btn>
          </div>
        </v-toolbar>

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $t('global.datestart')}}
                </th>
                <th class="text-left">
                  {{ $t('global.dateend')}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in connectors"
                :key="item.id"
              >
                <td>{{ formatDateTime(item['start'], 'long') }}</td>
                <td>{{ formatDateTime(item['end'], 'long') }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ConnectorList',
  servicePrefix: 'Application',
  mixins: [ListMixin,AccessMixin],
  components: {
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.datestart'), value: 'start' },
        { text: this.$t('global.dateend'), value: 'end' },
      ],
      selected: [],
      connectorsdata: null,
    };
  },
  mounted() {
    this.applicationGetData({data: 'historyconnector'});
  },
  computed: {
    isLoading() {
      return (
        this.isLoading 
       );
    },
    ...mapGetters('application',{
      data: 'data',
    }),
    ...mapFields('application', {
      error: 'error',
      isLoading: 'isLoading',
      updatedata: 'updatedata',
      action: 'action',
      actioned: 'actioned',
    }),
    connectors: {
      get() { return this.connectorsdata },
       set(value) { this.connectorsdata = value; }
    }
  },
  methods: {
    ...mapActions({
      applicationGetData: 'application/data'
    }),
    ...mapActions({
      applicationPushAction: 'application/action',
    }),
    startconnector() {
      this.applicationPushAction({action: 'connector',values: {}});
    },
    resultconnector(item) {
        console.log(item);
        item.message && this.showMessage(item.message);
    },
  },
  watch: {
    updatedata: function (updatedata) {
      if (updatedata == 'historyconnector') {
        this.connectorsdata = this.data('historyconnector');
      }
    },
    actioned(actioned) {
      if (!actioned) {
        return;
      }

      if (this.action == 'connector') {
        this.resultconnector(actioned);
      }
    },

  }
};
</script>
